import React from "react";

function ViewSubCategory({ data }) {

  return (
    <div className="custom-modal-body">

      <div className="model-custum">

        <h3>
          {data?.name}
        </h3>

        <div className="view-details-grid">

          <div className="view-detail-card">
            <span>ID</span>

            <h5>
             {data?.id}
            </h5>
          </div>

          <div className="view-detail-card">
            <span>Category</span>

            <h5>
              {data?.category_name}
            </h5>
          </div>

          <div className="view-detail-card">
            <span>Description</span>

            <h5>
              {data?.description}
            </h5>
          </div>

        </div>

      </div>

    </div>
  );
}

export default ViewSubCategory;